import { render, staticRenderFns } from "./BranchSetupWizard.vue?vue&type=template&id=58d84540&scoped=true&"
import script from "./BranchSetupWizard.vue?vue&type=script&lang=js&"
export * from "./BranchSetupWizard.vue?vue&type=script&lang=js&"
import style0 from "./BranchSetupWizard.vue?vue&type=style&index=0&id=58d84540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d84540",
  null
  
)

export default component.exports